<template>
  <main class="p-4 bg-white rounded shadow">
    <h1 class="text-xl font-bold mb-3">Aktivitas member</h1>
    <p class="mb-3">Pencatatan dimulai saat fitur ini diaktifkan, bukan riwayat lama. Login berarti autentikasi password berhasil; terakhir terlihat juga mencakup refresh token dan interaksi web. Akun admin/mentor tidak ditampilkan.</p>
    <form @submit.prevent="page = 1; load()" class="flex flex-wrap items-center gap-3 mb-4">
      <label for="activity-days">Terlihat dalam</label>
      <select id="activity-days" v-model.number="days" class="border rounded p-2" :disabled="loading">
        <option :value="7">7 hari</option><option :value="30">30 hari</option><option :value="90">90 hari</option><option :value="365">365 hari</option>
      </select>
      <button class="border rounded p-2" :disabled="loading" type="submit">Tampilkan</button>
    </form>
    <p v-if="error" role="alert" class="text-red-700 mb-3">{{ error }}</p>
    <p v-if="loading" role="status">Memuat aktivitas…</p>
    <p v-else class="mb-3">{{ total }} member teramati. Waktu ditampilkan dalam WIB.</p>
    <div class="overflow-x-auto" :aria-busy="loading">
      <table class="w-full text-sm">
        <caption class="text-left mb-2">Member terurut dari aktivitas terbaru</caption>
        <thead><tr><th>Member</th><th>Email</th><th>Login terakhir</th><th>Terlihat terakhir</th><th>Total login sejak pencatatan</th></tr></thead>
        <tbody>
          <tr v-for="member in members" :key="member.user_id">
            <td><router-link :to="'/user/' + encodeURIComponent(member.uuid) + '/detail'" class="underline">{{ member.name || member.uuid }}</router-link></td>
            <td>{{ member.email }}</td><td>{{ formatTime(member.last_login_at) }}</td><td>{{ formatTime(member.last_seen_at) }}</td><td>{{ member.login_count }}</td>
          </tr>
          <tr v-if="!loading && !error && !members.length"><td colspan="5">Belum ada aktivitas teramati pada periode ini. Ini tidak berarti semua member tidak aktif.</td></tr>
        </tbody>
      </table>
    </div>
    <nav aria-label="Halaman aktivitas" class="flex items-center gap-3 mt-4">
      <button class="border rounded p-2" :disabled="loading || page <= 1" @click="page--; load()">Sebelumnya</button>
      <span>Halaman {{ page }}</span>
      <button class="border rounded p-2" :disabled="loading || page * perPage >= total" @click="page++; load()">Berikutnya</button>
    </nav>
  </main>
</template>
<script>
import { UserApi } from '@/api/user'
export default {
  data: () => ({ members: [], total: 0, page: 1, perPage: 50, days: 90, loading: false, error: '' }),
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      this.error = ''
      this.members = []
      try {
        const { data } = await UserApi.getMemberActivity(this.days, this.page, this.perPage)
        this.members = data.data
        this.total = data.total
      } catch (_) {
        this.total = 0
        this.error = 'Aktivitas tidak dapat dimuat. Pastikan Anda admin dan layanan pencatatan sudah diaktifkan.'
      } finally { this.loading = false }
    },
    formatTime(value) {
      if (!value) return 'Belum teramati'
      return new Intl.DateTimeFormat('id-ID', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Jakarta' }).format(new Date(value * 1000))
    },
  },
}
</script>
<style scoped>
th, td { padding: .75rem; text-align: left; border-bottom: 1px solid #ddd; }
button:disabled { opacity: .5; cursor: not-allowed; }
button:focus-visible, a:focus-visible, select:focus-visible { outline: 2px solid #00446e; outline-offset: 3px; }
</style>
